export const RACES_FILTERS_FORM = 'RACES_FILTERS_FORM';
export const GET_RACES_LIST = 'GET_RACES_LIST';
export const GET_MAP_POINTS = 'GET_MAP_POINTS';
export const GET_RACE_CARD = 'GET_RACE_CARD';
